<template>
  <!-- Basic modal functionality of forms and vuex -->
  <xm-modal 
         :value="open"
         :title="title"
         @hide="$emit('closed')"
         @show="$emit('opened')"
         size="lg"
         :id="modalName"
         :save="save"
         :save-text="saveBtnText"
         :save-disabled="!formValid || !saveValid"
         :cancel-method="cancelMethod">
    <div>
      <form>
        <form-validator v-model="formValid">
          <slot></slot>
        </form-validator>
      </form>
    </div>
  </xm-modal>
</template>

<script>
  import FormValidator from '../FormValidator.vue'
  import XmModal from './XmModal.vue'

  export default {
    props: {
      open: {
        type: Boolean,
        required: false,
        default: false
      },
      title: {
        type: String,
        required: true
      },
      saveBtnText: {
        type: String,
        required: false,
        default: 'Submit'
      },
      modalName: {
        type: String,
        required: true
      },
      backdrop: {
        type: Boolean,
        required: false,
        default: true
      },
      save: {
        required: false,
        default: null
      },
      cancelMethod: {
        required: false,
        default: null
      },
      saveValid: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    data () {
      return {
        formValid: false
      }
    },

    methods: {
      setFormValid (valid) {
        if (valid) {
          this.$emit('valid')
        } else {
          this.$emit('invalid')
        }
      }
    },

    components: {
      FormValidator,
      XmModal,
    },

    watch: {
      'formValid': 'setFormValid'
    }
  }
</script>



// WEBPACK FOOTER //
// FormModal.vue?7e57ebea